import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, NgModule } from "@angular/core";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";

import { ShariahServiceProvider } from "../providers/shariah-service/shariah-service";

import { HttpClientModule } from "@angular/common/http";
import { MyApp } from "./app.component";
import { HomePage } from "../pages/home/home";
import { MenuPage } from "../pages/menu/menu";
import { AboutusPage } from "../pages/aboutus/aboutus";
import { ContactusPage } from "../pages/contactus/contactus";
import { LoginPage } from "../pages/login/login";
import { RegisterPage } from "../pages/register/register";
import { CartPage } from "../pages/cart/cart";
import { SlideContentPage } from "../pages/slidecontent/slidecontent";
import { SlidesPage } from "../pages/slides/slides";
import { SearchPage } from "../pages/search/search";
import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";
import { IonicImageViewerModule } from "ionic-img-viewer";
import { PortfoliosPage } from "../pages/portfolios/portfolios";
import { ListPage } from "../pages/list/list";
import { IntroSliderPage } from "../pages/intro-slider/intro-slider";
import { AppConfigProvider } from "../providers/app-config/app-config";
import { AuthServiceProvider } from "../providers/auth-service/auth-service";
import { TokenProvider } from "../providers/token/token";
import { IonicStorageModule } from "@ionic/storage";
import { ForgotpwdPage } from "../pages/forgotpwd/forgotpwd";
import { SettingPage } from "../pages/setting/setting";
import { UserCartsPage } from "../pages/user-carts/user-carts";
import { ContentpreviewPage } from "../pages/contentpreview/contentpreview";
import { TncPage } from "../pages/tnc/tnc";
import { SafeHtmlPipe } from "../pipes/safe-html/safe-html";
import { AccordionListComponent } from "../components/accordion-list/accordion-list";

import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    MenuPage,
    SlidesPage,
    AboutusPage,
    ContactusPage,
    SlideContentPage,
    RegisterPage,
    LoginPage,
    CartPage,
    TncPage,
    PortfoliosPage,
    IntroSliderPage,
    ListPage,
    SearchPage,
    ForgotpwdPage,
    SettingPage,
    SafeHtmlPipe,
    UserCartsPage,
    ContentpreviewPage,
    AccordionListComponent
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    IonicImageViewerModule,
    HttpClientModule,
    IonicStorageModule.forRoot()
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    MenuPage,
    SlidesPage,
    AboutusPage,
    ContactusPage,
    SlideContentPage,
    RegisterPage,
    LoginPage,
    CartPage,
    TncPage,
    PortfoliosPage,
    IntroSliderPage,
    ListPage,
    SearchPage,
    ForgotpwdPage,
    SettingPage,
    UserCartsPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    AuthServiceProvider,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    AppConfigProvider,
    TokenProvider,
    ShariahServiceProvider,
    InAppBrowser
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts